import { getInviteGroupIdFromSearch } from './inviteParams';

export const normalizeGroupCode = (value) => {
  const code = String(value || '').trim();
  try { return getInviteGroupIdFromSearch(new URL(code).search).toLowerCase(); }
  catch { return code.toLowerCase(); }
};

export const uniqueGroups = (groups) => {
  const result = new Map();
  groups.forEach((group) => {
    if (!group?.id) return;
    const existing = result.get(group.id);
    if (!existing || group.role === 'owner' || (group.role === 'admin' && existing.role !== 'owner')) result.set(group.id, group);
  });
  return [...result.values()];
};

export const uniqueGroupMembers = (members = []) => {
  const result = new Map();
  members.forEach((member) => {
    if (!member?.user_id) return;
    const key = `${member.group_id || ''}:${member.user_id}`;
    if (!result.has(key)) result.set(key, member);
  });
  return [...result.values()];
};
